var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3794 7.04459H13.9999",
    stroke: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.04459H8.92558",
    stroke: "#1D1D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42847 2.43069H14",
    stroke: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.43069H1.98026",
    stroke: "#1D1D1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86353 11.6585H14",
    stroke: "#1D1D1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6585H4.40954",
    stroke: "#1D1D1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70439 4.06845C4.65817 4.06845 5.43136 3.29526 5.43136 2.34148C5.43136 1.38769 4.65817 0.614502 3.70439 0.614502C2.75061 0.614502 1.97742 1.38769 1.97742 2.34148C1.97742 3.29526 2.75061 4.06845 3.70439 4.06845Z",
    stroke: "#1D1D1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6525 8.77157C11.6063 8.77157 12.3795 7.99838 12.3795 7.0446C12.3795 6.09082 11.6063 5.31763 10.6525 5.31763C9.69873 5.31763 8.92554 6.09082 8.92554 7.0446C8.92554 7.99838 9.69873 8.77157 10.6525 8.77157Z",
    stroke: "#1D1D1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13664 13.3855C7.09042 13.3855 7.86362 12.6123 7.86362 11.6585C7.86362 10.7047 7.09042 9.93155 6.13664 9.93155C5.18286 9.93155 4.40967 10.7047 4.40967 11.6585C4.40967 12.6123 5.18286 13.3855 6.13664 13.3855Z",
    stroke: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.dbbdddfdd7404e91c4e68fb9743b1438.svg";
export { ForwardRef as ReactComponent };